import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import { buildUseCaseActions } from '../reducers/build-usecases';
import BuildUseCaseService from '../api/useCaseService';

function* getUseCasesDataList({ payload }: any): any {
  const res = yield call(BuildUseCaseService.fetchAllUseCasesList, payload);
  if (res.status === 'success') {
    yield put(buildUseCaseActions.getAllUseCasesDataResponse(res));
  } else {
    yield put(buildUseCaseActions.getAllUseCasesDataFailed(res?.code));
  }
}

function* addUseCase({ payload }: any): any {
  const res = yield call(BuildUseCaseService.addNewUseCase, payload);
  if (res.status === 'success') {
    yield put(buildUseCaseActions.addUseCaseResponse(res?.code));
  } else {
    yield put(buildUseCaseActions.addUseCaseFailed(res?.code));
  }
}

function* removeUseCase({ payload }: any): any {
  const res = yield call(BuildUseCaseService.removeUseCase, payload);
  if (res.status === 'success') {
    yield put(buildUseCaseActions.removeUseCaseResponse(res?.code));
  } else {
    yield put(buildUseCaseActions.removeUseCaseFailed(res?.code));
  }
}

function* udpateUseCase({ payload }: any): any {
  const res = yield call(BuildUseCaseService.updateUseCase, payload);
  if (res.status === 'success') {
    yield put(buildUseCaseActions.updateUseCaseResponse(res?.code));
  } else {
    yield put(buildUseCaseActions.updateUseCaseFailed(res?.code));
  }
}

function* getUseCase({ payload }: any): any {
  const res = yield call(BuildUseCaseService.fetchUseCaseById, payload);
  if (res.status === 'success') {
    yield put(buildUseCaseActions.getUseCaseDataResponse(res));
  } else {
    yield put(buildUseCaseActions.getUseCaseDataFailed(res.code));
  }
}

function* deployUseCase({ payload }: any): any {
  const res = yield call(BuildUseCaseService.deployUseCase, payload);
  if (res.status === 'success') {
    yield put(buildUseCaseActions.updateUseCaseResponse(res.data));
  } else {
    yield put(buildUseCaseActions.updateUseCaseFailed(res?.code));
  }
}

function* udpateUseCaseStatus({ payload }: any): any {
  const res = yield call(BuildUseCaseService.updateUseCaseStatus, payload);
  if (res.status === 'success') {
    yield put(buildUseCaseActions.updateUseCaseStatusResponse(res?.code));
  } else {
    yield put(buildUseCaseActions.updateUseCaseStatusFailed(res?.code));
  }
}

function* BuildUseCaseSaga() {
  yield takeLatest('buildUseCase/getAllUseCasesDataRequest', getUseCasesDataList);
  yield takeLeading('buildUseCase/getUseCaseDataRequest', getUseCase);
  yield takeLeading('buildUseCase/addUseCaseRequest', addUseCase);
  yield takeLeading('buildUseCase/removeUseCaseRequest', removeUseCase);
  yield takeLeading('buildUseCase/updateUseCaseRequest', udpateUseCase);
  yield takeLeading('buildUseCase/deployUseCaseRequest', deployUseCase);
  yield takeLeading('buildUseCase/updateUseCaseStatusRequest', udpateUseCaseStatus);
}

export default BuildUseCaseSaga;
